import React, { Suspense, lazy } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Theatre from '@/components/edifice/Theatre/Theatre';
import Loading from '@/components/basic/Loading/Loading';
import RealmWrapper from '@/components/stage/Realm/RealmWrapper';
import ZoneWrapper from '@/components/stage/Zone/ZoneWrapper';
import MatrixWrapper from '@/components/stage/Matrix/MatrixWrapper';
import pageRegistryJson from '@/components/page/page-registry.json';

// 1. Dynamic Map Generation
const COMPONENT_MAP: Record<string, React.LazyExoticComponent<any>> = {};
pageRegistryJson
    .filter((item) => !item.isStub)
    .forEach((item) => {
        const compName = item.component;
        COMPONENT_MAP[compName] = lazy(
            () => import(`@/components/page/${compName}/${compName}`),
        );
    });

// 2. Route Generation
const generatedRoutes = pageRegistryJson
    .filter((item) => !item.isStub)
    .map((item) => {
        const LazyComp = COMPONENT_MAP[item.component];
        const isHome = item.path === '' || item.path === '/';

        return {
            ...(isHome ? { index: true } : { path: item.path }),
            element: (
                <Suspense fallback={<Loading />}>
                    <LazyComp />
                </Suspense>
            ),
        };
    });

const router = createBrowserRouter([
    {
        path: '/',
        element: <Theatre />,
        children: [
            ...generatedRoutes,
            { path: ':realmPath', element: <RealmWrapper /> },
            { path: ':realmPath/:zonePath', element: <ZoneWrapper /> },
            {
                path: ':realmPath/:zonePath/:matrixPath',
                element: <MatrixWrapper />,
            },
        ],
    },
]);

export default function Basement() {
    return <RouterProvider router={router} fallbackElement={<Loading />} />;
}
